export default __webpack_public_path__ + "static/media/rush-1.742aed43.png";